import { render } from "./SogCard.vue?vue&type=template&id=5edb8494&scoped=true"
const script = {}

import "./SogCard.vue?vue&type=style&index=0&id=5edb8494&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edb8494"]])

export default __exports__